import React, { Component } from 'react'
import '@loyal_template/placeholder.css'

class SummaryPlaceholder extends Component {
  render () {
    return (
      <div className='cart-side col-12 col-md-4 border-ui-3 radius bg-white px-0 py-0'>
        <div className='col-12 py-4 px-3 mx-0 border-color-ui-3 border-bottom'>
          <div className='row mx-0 shimmer'>
            <div className='col-8 py-half bg-ui-3 radius' />
          </div>
        </div>
        <div className='cart-subtotal col-12 pb-1 mx-0'>
          <div className='row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'>
            <div
              id='cart-subtotal-quantity'
              className='col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'
            >
              <div className='row mx-0'>
                <div className='col-8 py-half bg-ui-4 radius' />
              </div>
            </div>
            <div
              id='cart-subtotal-price'
              className='col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'
            >
              <div className='row  mx-0'>
                <div className='ml-auto col-7 py-half bg-ui-4 radius' />
              </div>
            </div>
          </div>
          <div className='row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'>
            <div
              id='cart-subtotal-quantity'
              className='col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'
            >
              <div className='row  mx-0'>
                <div className='col-8 py-half bg-ui-4 radius' />
              </div>
            </div>
            <div
              id='cart-subtotal-price'
              className='col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'
            >
              <div className='row  mx-0'>
                <div className='ml-auto col-7 py-half bg-ui-4 radius' />
              </div>
            </div>
          </div>
          <div className='row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'>
            <div
              id='cart-subtotal-quantity'
              className='col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'
            >
              <div className='row mx-0'>
                <div className='col-8 py-half bg-ui-4 radius' />
              </div>
            </div>
            <div
              id='cart-subtotal-price'
              className='col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'
            >
              <div className='row mx-0'>
                <div className='ml-auto col-7 py-half bg-ui-4 radius' />
              </div>
            </div>
          </div>
          <div className='row product-brand pt-2 px-2 '>
            <div
              id='cart-subtotal-quantity'
              className='col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'
            >
              <div className='row mx-0'>
                <div className='col-8 py-half bg-ui-4 radius' />
              </div>
            </div>
            <div
              id='cart-subtotal-price'
              className='col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'
            >
              <div className='row mx-0'>
                <div className='ml-auto col-7 py-half bg-ui-4 radius' />
              </div>
            </div>
          </div>
          <div className='cart-done row px-2 py-2'>
            <div className='col-12 justify-content-center align-self-center'>
              <div className='row mx-0 shimmer'>
                <div className='ml-auto col-12 pt-3 pb-2 bg-ui-3 radius' />
              </div>
            </div>
          </div>
          <div className='cart-done row px-2 pb-3'>
            <div className='col-12 justify-content-center align-self-center'>
              <div className='row mx-0'>
                <div className='col-11 py-half bg-ui-4 radius mb-1' />
                <div className='col-12 py-half bg-ui-4 radius' />

                <div className='col-6 mt-1'>
                  <div className='row'>
                    <div className='col-3 pt-1 pb-2 bg-ui-4 radius' />
                    <div className='col-3 pt-1 pb-2 bg-ui-4 radius ml-1' />
                    <div className='col-3 pt-1 pb-2 bg-ui-4 radius ml-1' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SummaryPlaceholder



// WEBPACK FOOTER //
// ./src/features/Cart/Summary/SummaryPlaceholder.js